import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

function useResendAdvisedApplicationInvite() {
  return api.incompleteInvestment.resendInvite.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Application invitation resent successfully.',
    }),
  );
}

export default useResendAdvisedApplicationInvite;
